import { render, staticRenderFns } from "./Attainment.vue?vue&type=template&id=23b1570c&scoped=true&"
import script from "./Attainment.vue?vue&type=script&lang=js&"
export * from "./Attainment.vue?vue&type=script&lang=js&"
import style0 from "./Attainment.vue?vue&type=style&index=0&id=23b1570c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1570c",
  null
  
)

export default component.exports